import React, { ButtonHTMLAttributes, useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { ContainerLineUI } from 'src/components/UIComponents/ContainerLine/styles';
import Subtitle from 'src/components/UIComponents/Subtitle';
import { hash, urlWebsite } from 'src/config';
import { useModal } from 'src/hooks/Modal';
import { loadFromJson } from 'src/utils/loadFromJson';

interface IProps {
  list?: Array<string>;
  projectHash?: string;
}

/*
  hook => interactions
*/

const SpeakerModule: React.FC<IProps> = ({ list = [], projectHash }) => {


  const { addModal } = useModal();
  const [speakers, setSpeakers] = useState<Array<Record<string, any>>>([])
  const loadList = async (IDs) => {
    const jsonData = await loadFromJson({ hash: hash, project_id: projectHash, table: 'Speaker' });

    const speakersList: Array<Record<string, any>> = [];

    jsonData?.map(i => {
      const index = IDs.findIndex(id => id === i?._id?.toString());

      if (index >= 0) {
        speakersList.push(i)
      }
    })

    setSpeakers(speakersList)

  }

  useEffect(() => {


    loadList(list)


  }, [list])

  const openDescription = (speaker: Record<string, any>) => {

    addModal({
      title: '', content: <div className='row-to-column'>
        <div style={{ width: '130px', height: '130px', borderRadius: '50%', background: speaker.photo ? `url('${urlWebsite}/${speaker.photo}')` : 'url("/apoio/user.jpg")' }} className="thumb grow" />

        <div className='column'>
          <Subtitle style={{ color: '#333', display: 'inline-block', fontSize: '16px' }} className="text-center max-200 pad-sm">{speaker?.name}</Subtitle>
          <p style={{ color: '#333' }} dangerouslySetInnerHTML={{ __html: speaker?.description || '' }} />
        </div>
      </div>, theme: 'whiteModalMedium'
    })

  }


  return <ContainerLineUI className='full-width row row-start gap-sm  flex-wrap' style={{ alignItems: 'stretch' }}  >
    {speakers?.map((authorInfo: Record<string, any>) => {

      return <div onClick={() => { openDescription(authorInfo) }} style={{ cursor: 'pointer', border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }} className='column max-160 pointer'>
        <div style={{ width: '130px', height: '130px', borderRadius: '50%', background: authorInfo.photo ? `url('${urlWebsite}/${authorInfo.photo}')` : 'url("/apoio/user.jpg")' }} className="thumb grow" />
        <Subtitle style={{ color: '#fff', display: 'inline-block', fontSize: '10px' }} className="text-center max-200 pad-sm">{authorInfo?.name}</Subtitle>
      </div>

    })}


  </ContainerLineUI>
};

export default SpeakerModule;
